<template>
 <div class='roba-loader'>
<svg viewBox="0 0 181 41" >
  <mask id="robaLogo">
    <path d="M0,1.06399993 L26.9039985,1.06399993 C37.0271979,1.06399993 43.1983975,4.86399971 43.1983975,12.9503992 C43.1983975,19.7599989 38.4255978,22.9519987 33.0751981,22.9519987 L33.0751981,23.1343987 C37.6655978,23.8639986 40.3711977,27.6031984 41.4655976,31.9503982 L43.5023975,40.0367977 L30.7039982,40.0367977 L28.8799983,32.4975981 C28.0895984,29.2447983 26.2959985,27.1167984 22.2527987,27.1167984 L12.0687993,27.1167984 L12.0687993,40.0367977 L0,40.0367977 L0,1.06399993 Z M25.6879985,18.057599 C29.0015983,18.057599 30.7647982,16.780799 30.7647982,14.1967992 C30.7647982,11.5519993 29.0015983,10.2751994 25.6879985,10.2751994 L12.0687993,10.2751994 L12.0687993,18.057599 L25.6879985,18.057599 L25.6879985,18.057599 Z" fill="white"></path>
    <path d="M43.3503975,20.5503988 C43.3503975,8.72479949 52.531197,0.759999945 66.0895962,0.759999945 L69.281596,0.759999945 C82.9007953,0.942399935 92.0815947,8.90719948 92.0815947,20.5503988 C92.0815947,32.1935981 82.9007953,40.1583977 69.281596,40.3407977 L66.1503962,40.3407977 C52.531197,40.3103977 43.3503975,32.3455981 43.3503975,20.5503988 Z M55.9055968,20.5503988 C55.9055968,26.7519985 60.4351965,30.7343982 67.5487961,30.7343982 L67.9135961,30.7343982 C75.0271957,30.7343982 79.5567954,26.7519985 79.5567954,20.5503988 C79.5567954,14.3487992 75.0271957,10.3662266 67.9135961,10.3662266 L67.5487961,10.3662266 C60.4351965,10.3359994 55.9055968,14.3183992 55.9055968,20.5503988 Z" fill="white"></path>
    <path d="M93.2975947,1.06399993 L121.083193,1.06399993 C130.537593,1.06399993 135.796792,4.55999973 135.796792,11.5519993 C135.796792,17.054399 131.996792,19.7599989 128.014393,20.2463988 L128.014393,20.4287988 C132.604792,20.4895988 136.587192,23.6815986 136.587192,29.4271983 C136.587192,36.1759979 131.631992,40.0367977 120.961593,40.0367977 L93.2671947,40.0367977 L93.2671947,1.06399993 L93.2975947,1.06399993 Z M119.350393,16.3855991 C121.995193,16.3855991 123.393593,15.3519991 123.393593,13.3151992 C123.393593,11.2783993 121.995193,10.1839994 119.350393,10.1839994 L105.366394,10.1839994 L105.366394,16.3855991 L119.350393,16.3855991 L119.350393,16.3855991 Z M120.110393,30.9167982 C122.815993,30.9167982 124.275193,29.8223983 124.275193,27.7247984 C124.275193,25.6271985 122.815993,24.5935986 120.110393,24.5935986 L105.335994,24.5935986 L105.335994,30.9167982 L120.110393,30.9167982 Z" fill="white"></path>
    <path d="M168.90239,27.6639984 L149.780791,27.6639984 L149.780791,40.0367977 L137.711992,40.0367977 L137.711992,21.1887988 C137.711992,9.11999947 146.831992,1.03359993 159.417591,1.03359993 L180.94079,1.03359993 L180.94079,39.9759977 L168.87199,39.9759977 L168.87199,27.6639984 L168.90239,27.6639984 Z M150.084791,18.6047989 L168.90239,18.6047989 L168.90239,10.5791994 L160.268791,10.5791994 C154.614391,10.5791994 151.118391,13.3759992 150.084791,18.6047989 Z" fill="white" ></path>
  </mask>

  <!-- apply the roba logo as mask to a gray and green rectangle -->
  <g mask="url(#robaLogo)">
    <rect fill='rgba(0,0,0,0.12)' x='0' y='0'  width='100%' height='100%' />
    <!-- transform width of skewed rectangle  -->
    <rect transform='skewX(-20)' class='fill-primary' x='0' y='0' :width='width' height='100%' />
  </g>
</svg>

    </div>
</template>

<script lang='ts'>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    percentage: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const width = computed(() => `${props.percentage * 1.08}%`)

    return {
      width,
    }
  },
})
</script>
<style lang='scss' scoped>
.roba-loader svg{
  height:41px;

  .fill-primary{
    fill:$primary;
  }
}
</style>
